module.exports = __webpack_public_path__ + "img/logo-icon.be29ddfc.png";